import type { FunctionComponent, SVGProps } from "react";
import { LocalizationKeys, type LocalizationKey } from "../../i18n";
import NotWatched from "../../assets/icons/notWatched2.svg?react";
import TrackIcon from "../../assets/icons/track.svg?react";
import Watched from "../../assets/icons/watched.svg?react";
import StopWatchIcon from "../../assets/icons/stopWatch.svg?react";
import DelayedIcon from "../../assets/icons/historyIcon.svg?react";

type SvgIconComponent = FunctionComponent<SVGProps<SVGSVGElement>>;

/**
 * Consume Type enum - статусы просмотра контента
 */
export enum ConsumeType {
  UNSPECIFIED = 0,
  WATCHING = 1,
  WATCHED = 2,
  DELAYED = 3,
  TRASH = 4,
}

/**
 * i18n keys for ConsumeType enum values
 */
export const CONSUME_TYPE_I18N_KEYS: Record<ConsumeType, LocalizationKey> = {
  [ConsumeType.UNSPECIFIED]: LocalizationKeys.CONSUME_TYPE_UNSPECIFIED,
  [ConsumeType.WATCHING]: LocalizationKeys.CONSUME_TYPE_WATCHING,
  [ConsumeType.WATCHED]: LocalizationKeys.CONSUME_TYPE_WATCHED,
  [ConsumeType.TRASH]: LocalizationKeys.CONSUME_TYPE_TRASH,
  [ConsumeType.DELAYED]: LocalizationKeys.CONSUME_TYPE_DELAYED,
};

/**
 * Icon color variants for ConsumeType
 */
export type ConsumeTypeIconColor = "default" | "yellow" | "accent" | "red";

/**
 * Icon configuration for ConsumeType enum values
 */
export interface ConsumeTypeIconConfig {
  Icon: SvgIconComponent;
  color: ConsumeTypeIconColor;
  mirrored?: boolean;
}

export const CONSUME_TYPE_ICON_CONFIG: Record<
  ConsumeType,
  ConsumeTypeIconConfig
> = {
  [ConsumeType.UNSPECIFIED]: { Icon: NotWatched, color: "default" },
  [ConsumeType.WATCHING]: { Icon: TrackIcon, color: "yellow" },
  [ConsumeType.WATCHED]: { Icon: Watched, color: "accent" },
  [ConsumeType.TRASH]: { Icon: StopWatchIcon, color: "red" },
  [ConsumeType.DELAYED]: { Icon: DelayedIcon, color: "yellow", mirrored: true },
};
